import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '病歷號',
    model: 'patient_no',
    placeholder: '病歷號',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '怡仁病歷號',
    model: 'yeezen_no',
    placeholder: '怡仁病歷號',
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '姓名',
    model: 'name',
    placeholder: '姓名',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-radios',
    label: '性別',
    model: 'gender',
    style: 'matrix',
    required: true,
    values() {
      return [
        { "value": "M", "name": "男" },
        { "value": "F", "name": "女" },
        { "value": "X", "name": "其他" }
      ];
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '身分證字號',
    model: 'twid',
    placeholder: '身分證字號',
    required: true,
    validator: function () {      
      this.validation();
      if(this.model.twid){
        
        var xmlHttp = new XMLHttpRequest();
        if(this.$route.params.id==undefined){
          xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/check-user-twid?twid='+this.model.twid, false);  
        }else{
          xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/check-user-twid?id='+this.$route.params.id+'&twid='+this.model.twid, false);  
        }
        
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
        xmlHttp.send();
        if(JSON.parse(xmlHttp.responseText).result){
          this.inputError = true;
          this.errorMessage = "此身份證已存在";
        }    

      }        
    },
  },
  {
    type: 'bsx-date-picker',
    label: '生日',
    model: 'birthday',
    placeholder: '格式：YYYY-MM-DD',
    min: '1900-01-01',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '手機',
    model: 'phone',
    placeholder: '手機',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '信箱',
    model: 'email',
    placeholder: '信箱',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '地址',
    model: 'address',
    placeholder: '地址',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-label',
    label: '是否已填寫全初診表',
    model: 'first_diagnosis',
  },
  {
    type: 'bsx-label',
    label: '本國人',
    model: 'is_foreign_text',
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    textOn: '啟用',
    textOff: '停用',
    valueOn: 'NORMAL',
    valueOff: 'DISABLE',
  },
  {
    type: 'bsx-toggle',
    label: '是否修改密碼',
    model: 'is_change_password',
    textOn: '是',
    textOff: '否',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
  {
    type: 'bsx-input',
    inputType: 'password',
    label: '密碼',
    model: 'password',
    placeholder: '密碼',
    required: true,
    visible: (model) => model.is_change_password == 'ON',
    validator: function () {
      this.validation();
    },
  }
];

export default fields;
